import * as yup from 'yup'
import {
    KYC_MAX_CARDS,
    maxSingleCardLoad,
    minCardLoad,
    minCardsBox,
} from '@/src/modules/checkout/strings'
import {
    cardTextMax,
    cardTextMin,
    embossRegexYup,
} from '@/src/modules/build-a-card/constants'
import postLanguageCheck from '@/src/common/queries/PostLanguageCheckQuery'

export const BoxStep1Schema = yup.object({
    cardQuantity: yup
        .number()
        .label('Card quantity')
        .required('Please select a card quantity')
        .test(
            'quantityValueLegit',
            `Card quantity must be between ${minCardsBox} and ${KYC_MAX_CARDS}`,
            (value: number | undefined) => {
                if (!value) return false
                return minCardsBox <= value && value <= KYC_MAX_CARDS
            }
        ),
    denomination: yup
        .string()
        .label('Amount')
        .required()
        .test(
            'denomValueLegit',
            `Amount must be between $${minCardLoad} and $${maxSingleCardLoad}`,
            (value: string | undefined) => {
                if (!value) return false
                const floatVal = parseFloat(value?.replace(/[^0-9.]+/g, ''))
                return minCardLoad <= floatVal && floatVal <= maxSingleCardLoad //@FUTURE: Dynamic data from server side.
            }
        ),
    designImage: yup
        .string()
        .label('Design')
        .required('Please upload a photo or select a pre-designed image')
        .url(),
    nameOnCard: yup
        .string()
        .label('Name')
        .required()
        .matches(
            embossRegexYup,
            'Only alphanumeric characters and hyphens are allowed'
        )
        .min(
            cardTextMin,
            `Name on card must contain at least ${cardTextMin} characters`
        )
        .max(
            cardTextMax,
            `Name on card cannot contain more than ${cardTextMax} characters`
        )
        .test(
            'badWords',
            'Contains words or phrases that are not permitted',
            postLanguageCheck
        ),
    messageOnCard: yup
        .string()
        .label('Message')
        .required()
        .matches(
            embossRegexYup,
            'Only alphanumeric characters and hyphens are allowed'
        )
        .min(
            cardTextMin,
            `Message must contain at least ${cardTextMin} characters`
        )
        .max(
            cardTextMax,
            `Message cannot contain more than ${cardTextMax} characters`
        )
        .test(
            'badWords',
            'Contains words or phrases that are not permitted',
            postLanguageCheck
        ),
})
